/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */

import React, { useCallback, useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import CityDropdown from '../CityDropdown';
import DurationDropdown from '../DurationDropDown';
import MerchantDrodown from '../MerchantDrodown';

function DoughnutGraph({
    graphDetails,
    selectedFilter,
    handleSetFilterValues,
    cityList,
    MerchantList,
    handleClearFilter,
    GraphKey
}) {

    const [loadingPage, setLoadingPage] = useState(true)
    const [totalValue, setTotalValue] = useState(0);
    const [dynamicData, setDynamicData] = useState({})
    const [topPosition, setTopPosition] = useState(window.innerWidth <= 1285 ? '45%' : '45%');

    useEffect(() => {
        const handleResize = () => {
            const newTopPosition = window.innerWidth <= 1285 ? '45%' : '45%';
            setTopPosition(newTopPosition);
        };

        handleResize(); // Initial calculation
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const [cityDropdownisOpen, setCityDropdownIsOpen] = useState(false);

    const handleFiterOptionClick = (value, key) => {
        handleSetFilterValues(value, "products_with_nft", key)
        setCityDropdownIsOpen(false)
    }

    const getDetails = useCallback(async (filterParams = {}) => {
        setDynamicData({
            labels: graphDetails?.[selectedFilter.duration]?.map((data) => data.label),
            datasets: [
                {
                    label: "",
                    data: graphDetails?.[selectedFilter.duration]?.map((data) => data.value),
                    backgroundColor: ["#9E2064", "#EB9DC7"], // You can update this if needed
                    borderColor: ["#9E2064", "#EB9DC7"], // You can update this if needed
                    borderWidth: 1,
                },
            ],
        })
        let total = 0;
        Object.keys(graphDetails).forEach(key => {
            total += graphDetails[key].reduce((acc, curr) => acc + curr.value, 0);
        });
        setTotalValue(total);
        setLoadingPage(false);
    }, [graphDetails]);

    useEffect(() => {
        getDetails()
    }, [getDetails])

    const options = {
        plugins: {
            legend: {
                display: true,
                beginAtZero: true,
                position: 'bottom', // Change the position of the legend
                labels: {
                    boxWidth: 20, // Set the width of the legend box
                    borderRadius: 100, // Make the legend box round
                },
            },
        },
        hover: {
            mode: null, // Disable hover effect
        },
    };
    const handleCityDropdownClose = () => {
        setCityDropdownIsOpen(false);
    };
    return (
        <>
            {totalValue === 0 ? (
                <div className='p-6 w-full'>
                    <div className='w-full flex 2xl:flex-row flex-col justify-between items-start'>
                        <p className='font-normal text-lg text-[#4B4B4B] w-[70%]'>Products with NFT</p>
                        <div className='flex items-center justify-end w-full'>
                            <MerchantDrodown
                                MerchantList={MerchantList}
                                handleMerchantOptionClick={handleFiterOptionClick}
                                selectedFilter={selectedFilter.merchant}
                                handleClearFilter={handleClearFilter}
                                GraphKey={GraphKey}
                            />
                            <CityDropdown
                                cityList={cityList}
                                cityDropdownisOpen={cityDropdownisOpen}
                                setCityDropdownIsOpen={setCityDropdownIsOpen}
                                handleCityOptionClick={handleFiterOptionClick}
                                selectedFilter={selectedFilter.city}
                                buttonDisabled={selectedFilter.merchant !== null}
                                handleClearFilter={handleClearFilter}
                                GraphKey={GraphKey}
                                handleCityDropdownClose={handleCityDropdownClose} // Pass the function as a prop
                            />
                            <DurationDropdown
                                handleOptionClick={handleFiterOptionClick}
                                selectedFilter={selectedFilter.duration}
                            />
                        </div>
                    </div>
                    <div className='text-xl text-center font-normal text-black pt-[5%]'>
                        <img src="/assets/images/notfoundPage.svg" alt="NotFound" className="pb-6 mx-auto w-[90%] h-[370px]" />
                        No data available</div>
                </div>) :
                <div className='p-6 w-full'>
                    <div className='w-full flex 2xl:flex-row flex-col justify-between items-start'>
                        <p className='font-normal text-lg text-[#4B4B4B] w-[70%]'>Products with NFT</p>
                        <div className='flex items-center justify-end w-full'>
                            <MerchantDrodown
                                MerchantList={MerchantList}
                                handleMerchantOptionClick={handleFiterOptionClick}
                                selectedFilter={selectedFilter.merchant}
                                handleClearFilter={handleClearFilter}
                                GraphKey={GraphKey}
                            />
                            <CityDropdown
                                cityList={cityList}
                                cityDropdownisOpen={cityDropdownisOpen}
                                setCityDropdownIsOpen={setCityDropdownIsOpen}
                                handleCityOptionClick={handleFiterOptionClick}
                                selectedFilter={selectedFilter.city}
                                buttonDisabled={selectedFilter.merchant !== null}
                                handleClearFilter={handleClearFilter}
                                GraphKey={GraphKey}
                                handleCityDropdownClose={handleCityDropdownClose} // Pass the function as a prop
                            />
                            <DurationDropdown
                                handleOptionClick={handleFiterOptionClick}
                                selectedFilter={selectedFilter.duration}
                            />
                        </div>
                    </div>
                    <div className='py-5 pl-5 pr-10 w-full h-full flex justify-center'>
                        <div style={{
                            position: 'relative',
                            width: window.innerWidth <= 1280 ? '280px' : '400px',
                            height: window.innerWidth <= 1280 ? '280px' : '400px',
                            margin: '0 auto'
                        }}>

                            <Doughnut data={dynamicData} options={options} />

                            {/* Total value */}
                            <div style={{
                                position: 'absolute',
                                top: topPosition,
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                textAlign: 'center',
                                width: '100%'
                            }}>
                                <h2 className='font-bold text-2xl text-[#1F1F1F]'>{totalValue}</h2>
                                <h6 className='font-normal text-sm text-[#8E8E8E]'>Total</h6>
                            </div>
                        </div>
                    </div>

                </div>}
        </>
    );
}

export default DoughnutGraph;

